module.exports = __webpack_public_path__ + "static/media/credit-card.2389f460.svg";